export default __webpack_public_path__ + "static/media/arrow_free_size.b70aa89b.svg";